export default __webpack_public_path__ + "static/media/briefcase-logo-horizontal-02.7ace68eb.png";